<template>
  <div class="row">
    <div class="col-12">
      <div class=" align-items-center mb-2">
        <div class="row">
          <div class="col-9">
            <h4 class="mb-0 ml-75">
              <feather type="layers" class="font-medium-3 mr-1">
              </feather>
              Sub Department
            </h4>

          </div>
          <div class="col-3">
            <div class="d-flex align-items-center justify-content-end">
              <button type="button" @click="back"
                      class="btn btn-sm ">
                <feather type="arrow-left" class="font-medium-3">
                </feather>
              </button>


              <button type="button" @click="createSubDepartment"
                      class="btn btn-primary btn-sm ml-75">
                <span class="text-nowrap">Create</span>
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <small class="mb-0 mt-0 ml-3 text-primary">
              Assign Department For {{ data.name }}
            </small>

          </div>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table">
        <thead>
        <tr>
          <th class="py-1">S.No</th>
          <th class="py-1">Name</th>
          <th class="py-1">Actions</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in subDepartments" :key="index">
          <td class="py-1">
            <span class="font-weight-bold">{{ index + 1 }}</span>
          </td>
          <td class="py-1">
            <span class="font-weight-bold">{{ item.name }}</span>
          </td>
          <td class="d-flex">

            <button class="btn btn-sm btn-primary  btn-sm"
                    @click="updateSubDepart(item)">Update
            </button>
            <button class="btn btn-sm btn-primary btn-sm ml-1"
                    @click="assignDepartment(item,index)">Assign
              Staff
            </button>
            <div
                class="custom-control custom-control-success custom-switch ml-1">
              <input type="checkbox" :id="item._id"
                     v-model="item.status" @change="deleteRecord(item)"
                     class="custom-control-input"><label :for="item._id"
                                                         class="custom-control-label"></label>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <SubDepartmentCreateModal :forUpdate="false" :data="modalData" @completed="createComplete"
                              :show="showCreateDepartmentModel" @hide="showCreateDepartmentModel = false"/>
    <SubDepartmentCreateModal :forUpdate="true" :data="modalData" @completed="updateComplete"
                              :show="showUpdateDepartmentModel" @hide="showUpdateDepartmentModel = false"/>

    <DepartmentAssignStaff @completed="completedAssignStaff" :alreadySelectedMerchants="alreadySelectedMerchants" :row="rowData" :data="MerchantsData" :show="showAssignStaffModel" @hide="showAssignStaffModel = false"/>
  </div>
</template>
<script>
import SubDepartmentCreateModal from "./SubDepartmentCreateModal.vue";
import DepartmentAssignStaff from "../../DepartmentAssignStaff.vue";

export default {
  components: {
    SubDepartmentCreateModal,
    DepartmentAssignStaff
  },
  props: ['data'],
  mounted() {
    this.subDepartments = []
    this.getMerchantData()
    if (this.data?.subDepartments?.length > 0 && typeof (this.data?.subDepartments[0]?.name) != "undefined") {
      this.subDepartments = this.data?.subDepartments || []
    }
  },
  data() {
    return {
      index:null,
      rowData: {},
      modalData: {},
      subDepartments: [],
      showCreateDepartmentModel: false,
      showUpdateDepartmentModel: false,
      showAssignStaffModel: false,
      MerchantsData: [],
      alreadySelectedMerchants: [],
    };
  },
  methods: {
    completedAssignStaff(val) {
      this.subDepartments[this.index] = {
        ...this.rowData,
        assignees: val
      }
      this.showAssignStaffModel = false
    },
    getMerchantData() {
      this.makeRequest("post", "v1/get-admin-user", {flag: "active"}, {}, false, true, [205]).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                this.MerchantsData = responseData;
              }
            }
          }
      );
    },
    deleteRecord(row) {
      this.makeRequest("post", "v1/cms-update-sub-department", {
        status: row.status == true ? 1 : 0,
        id: row._id,
      });
    },
    createSubDepartment() {
      this.modalData = {
        parentId: this.data._id,
      }
      this.showCreateDepartmentModel = true
    },
    createComplete(val) {
      this.subDepartments.push(val)
      this.showCreateDepartmentModel = false
    },
    updateComplete(val) {
      this.subDepartments = this.subDepartments.map(item => {
        if (item._id == val._id) {
          return val
        }
        return item
      })
      // this.subDepartments.push(val)
      this.showUpdateDepartmentModel = false
    },
    updateSubDepart(item) {
      this.modalData = {
        name: item.name,
        id: item._id,
        status: item.status == true ? 1 : 0,
      }
      this.showUpdateDepartmentModel = true
    },
    assignDepartment(item,index) {
      this.index = index
      let assignees = []
      if(item?.assignees?.length > 0){
        item.assignees.map((assignee)=>{
          assignees.push(assignee._id)
        })
      }
      this.rowData = item


      this.alreadySelectedMerchants = assignees
      this.showAssignStaffModel = true
    },
    back(){
      let data = this.$store.getters.getTableData(this.data.storageKey+'_custom')
      let rowProp = this.data
      rowProp.subDepartments = this.subDepartments
      data[this.data.idx] = rowProp
      this.$store.dispatch('setTableData', { key: this.data.storageKey+'_custom', data: {...data} })
      this.$emit('back')
    }

  },
  watch: {
    data(val) {
      this.subDepartments = []
      if (this.data?.subDepartments?.length > 0 && typeof (this.data?.subDepartments[0]?.name) != "undefined") {
        this.subDepartments = this.data?.subDepartments || []
      }
    }
  }
}
</script>